module.exports = __webpack_public_path__ + "static/media/CHERI-01.614b14a8.svg";